import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { COMPONENTES_INTERNOS } from '../config/componentes-internos.config';
import { normalizarChave } from '../../shared/utils/normalizarChave';
import { PainelFuncionalidadesService } from '../../shared/services/painel-funcionalidades/painel-funcionalidades.service';

/**
 * Mantém no painel de funcionalidades as telas que podem ser embutidas.
 *
 * Com o painel na tela, uma navegação para uma rota mapeada em
 * COMPONENTES_INTERNOS é cancelada e reencaminhada para o painel — é o que faz
 * "Novo Cadastro" e "Editar", dentro de Cadastro de Menus, abrirem o
 * Configurar Menu ali mesmo, sem tirar o usuário do módulo.
 *
 * Fora do painel (acesso direto pela URL, por exemplo) a rota abre normalmente.
 */
@Injectable({
  providedIn: 'root',
})
export class PainelEmbutidoGuardService implements CanActivate {
  constructor(private painelFuncionalidades: PainelFuncionalidadesService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.painelFuncionalidades.painelAtivo) {
      return true;
    }

    const rota = state.url.split('?')[0];

    if (!COMPONENTES_INTERNOS[normalizarChave(rota)]) {
      return true;
    }

    this.painelFuncionalidades.abrir(rota, route.queryParams);

    return false;
  }
}
